import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import { Search } from "@material-ui/icons"
import { useContext, useEffect, useState } from "react"
import { useQuery } from "react-query"
import { useHistory } from "react-router-dom"
import { giveCourse, listPublishedCourses } from "~/actions/courses"
import LoaderButton from "~/components/LoaderButton/index.jsx"
import AddedCourseCard from "~/components/Users/AddedCourseCard"
import AppContext from "~/contexts/App"

// import { giveCourse } from "~/actions/courses"
import Box from "~/components/Common/Box"
import useStyles from "./styles"

const AddUserToCourse = () => {
  const classes = useStyles()
  const theme = useTheme()
  const history = useHistory()
  const { dialogs, closeDialog, openSnackBar, authUser } =
    useContext(AppContext)
  const thisDialog = dialogs?.["addUserToCourse"] || {}
  const { open = false, data } = thisDialog

  const { data: publishedCourses } = useQuery(
    "publishedCourses",
    () => listPublishedCourses(),
    {
      enabled: !!authUser,
    },
  )
  const [searchValue, setSearchValue] = useState("")
  const [filteredCourses, setFilteredCourses] = useState([])
  const [addedCourses, setAddedCourses] = useState([])
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))
  //close dialog set search value to empty string and
  //set component array state to the context state
  const handleClose = () => {
    closeDialog("addUserToCourse", false)
    setAddedCourses([])
    setSearchValue("")
    //setAddedCourses(courseArray)
  }

  //open Lesson dialog
  const openCourses = () => {
    history.push("/courses")
    handleClose()
  }

  //close the dialog
  const addCourses = async () => {
    //  setCourseArray(addedCourses)
    await addedCourses.map((course) => {
      giveCourse(data.data, course.id)
    })
    //giveCourse(addedCourses, )
    handleClose()
  }

  ///set course array in context to a component state to only replace the context array
  // useEffect(() => {
  //   setAddedCourses(courseArray)
  // }, [courseArray])

  // fitered data using searchValue
  useEffect(() => {
    if (publishedCourses) {
      let newArray = [...publishedCourses]
      if (searchValue.length > 0) {
        newArray = publishedCourses?.filter((course) => {
          return course?.versions[0].name
            .toLowerCase()
            .includes(searchValue.toLowerCase())
        })
      } else if (searchValue === "") {
        newArray = publishedCourses
      }
      setFilteredCourses(newArray)
    }
  }, [searchValue, publishedCourses])

  return (
    <Dialog
      classes={{ paperWidthSm: classes.dialogContainer }}
      open={open}
      fullScreen={smDown}
    >
      <DialogTitle className={classes.dialogTitle}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          className={classes.dialogTop}
        >
          <Typography variant="h2" className={classes.title}>
            Add Course
          </Typography>
          <TextField
            placeholder="Search courses"
            className={classes.search}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                setSearchValue(e.target.value)
              }
            }}
            onChange={(e) => e.target.value === "" && setSearchValue("")}
            InputProps={{
              disableUnderline: true,
              startAdornment: (
                <InputAdornment position="start" style={{ marginLeft: "10px" }}>
                  <Search className={classes.searchIcon} />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        {!publishedCourses ? (
          <CircularProgress />
        ) : (
          filteredCourses?.map((course) => {
            return (
              <AddedCourseCard
                course={course}
                key={course.id}
                addedCourses={addedCourses}
                setAddedCourses={setAddedCourses}
              />
            )
          })
        )}
      </DialogContent>
      <DialogActions
        style={{
          position: "absolute",
          bottom: 4,
          width: "100%",
        }}
        className={classes.actions}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          width="100%"
          marginLeft="20px"
          marginRight="20px"
          className={classes.actionBox}
        >
          <Box>
            <Button className={classes.remove} onClick={openCourses}>
              Create Course
            </Button>
          </Box>
          <Box>
            <Button
              onClick={handleClose}
              style={{ height: "40px", marginRight: "10px" }}
            >
              Cancel
            </Button>
            <LoaderButton
              onClick={addCourses}
              classoverrides={{
                wrapper: classes.button,
                button: {
                  root: classes.buttonRoot,
                },
              }}
              variant="contained"
              color="secondary"
              size="small"
            >
              add
            </LoaderButton>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

AddUserToCourse.propTypes = {}

export default AddUserToCourse
